"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToolbarHeight = exports.TOOLBAR_VERT_PADDING = void 0;
const TOOLBAR_VERT_PADDING = 4;
exports.TOOLBAR_VERT_PADDING = TOOLBAR_VERT_PADDING;
const getToolbarHeight = size => {
  switch (size) {
    case "xxSmall":
      return 20;
    case "small":
      return 32;
    case "medium":
      return 36;
    default:
      return 40;
  }
};
exports.getToolbarHeight = getToolbarHeight;
//# sourceMappingURL=utils.js.map